import React, {useEffect, useState} from "react";
import {Button, Drawer, Grid, IconButton, TextField} from "@material-ui/core";
import Comment from "../../services/dto/Comment";
import {FaRegTrashCan} from "react-icons/fa6";
import {inspectionService} from "../../services/InspectionService";
import {IoMdClose} from "react-icons/io";
import {id} from "date-fns/locale";

export interface CommentFormProps {
    open: boolean,
    handleClose: () => void,
    inspectionId: number,
    comment: Comment,
    onDidSaveComment: (comments: Comment[]) => void
}
export const CommentForm : React.FC<CommentFormProps> = ({open, handleClose, comment,
                                                             inspectionId, onDidSaveComment}) => {

    const [id :number, setId] = useState()
    const [key :string, setKey] = useState()
    const [keyError, setKeyError] = useState()
    const [content :string, setContent] = useState()
    const [contentError, setContentError] = useState()

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(comment) {
            setId(comment.id);
            setKey(comment.key);
            setContent(comment.content);
        } else {
            setId(undefined);
            setKey(undefined);
            setContent(undefined);
        }
    }, [comment]);

    const deleteComment = () => {
        const confirmAnswer = window.confirm("Soll dieser Hinweis wirklich gelöscht werden?");
        if(confirmAnswer) {
            setLoading(true);
            inspectionService.deleteComment(inspectionId, id).then((comments: Comment[]) => {
                onDidSaveComment(comments);
                handleClose();
                setLoading(false);
            })
        }

    }

    const saveComment = () => {
        let hasError = false;
        if(!key || key.length < 1) {
            setKeyError('Bitte Referenz für Hinweis angeben')
            hasError = true;
        }
        if(!content || content.length < 1) {
            setContentError('Bitte Hinweistext angeben')
            hasError = true;
        }
        if(!hasError) {
            let newComment = new Comment(id, key, content);
            setLoading(true)
            inspectionService.saveComment(inspectionId, newComment).then((comments: Comment[]) => {
                onDidSaveComment(comments);
                setLoading(false)
                handleClose();
            })
        }
    }

    return (
        <Drawer PaperProps={{style: {maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto', padding: '20px'}}} anchor={'bottom'} open={open}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h1 style={{padding: '0px', marginTop: '0px', marginBottom: '5px'}}>Hinweis {id ? 'bearbeiten' : 'erstellen'}</h1>
                </Grid>
                    <IconButton style={{position: 'absolute', right: '5px', top:'18px', color: 'black'}} onClick={handleClose}><IoMdClose size={30} /></IconButton>
                <Grid item xs={12}>
                    <TextField label={'Person / Raum'} onChange={event => {
                        setKey(event.target.value);
                        setKeyError(undefined);
                    }} value={key} variant={'outlined'} fullWidth
                    error={!!keyError} helperText={keyError}></TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField label={'Hinweistext'} onChange={event => {
                        setContent(event.target.value);
                        setContentError(undefined);
                    }} value={content} variant={'outlined'} multiline={true} maxRows={4} minRows={4} fullWidth
                    error={!!contentError} helperText={contentError}></TextField>
                </Grid>
                {!!id && (
                    <Grid item>
                        <Button disabled={loading} style={{padding: '10px'}} color={'secondary'}
                                variant={'contained'} size={'medium'}><FaRegTrashCan size={'22'}
                                onClick={() => {
                                    deleteComment();
                                }}
                        /></Button>
                    </Grid>
                )}
                <Grid item xs={true}>
                    <Button disabled={loading} fullWidth variant={'contained'} color={'primary'} size={'large'} onClick={() => {
                        saveComment();
                    }}>Speichern</Button>
                </Grid>
            </Grid>





        </Drawer>

    )
}